import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {WalletService} from '../wallet.service';
import {BankRequest, SticpayTransactionRequest} from '../../../models/transaction.model';
import {Constants} from '../../../shared/utils/constants';
import {NgForm} from '@angular/forms';
import {AppService} from '../../../app.service';
import {Permission} from '../../../models/permission.model';
import { ExportExcelColumn, ExportService } from 'src/app/shared/services/export.service';
import { DatePipe, DecimalPipe } from '@angular/common';

declare var $: any;
@Component({
  selector: 'fx-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.sass']
})
export class RequestComponent implements OnInit, OnDestroy  {
  @Input() permission: Permission;
  @ViewChild('formChangeAmount') formChangeAmount: NgForm;
  @Input() type: string;
  subscription: Subscription;
  data: any[] = [];
  condition: any = {
    asset: '',
    type: '',
    code: '',
    status: '',
    q: '',
  };
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  loading = false;
  pointUpdate = null;
  re = /-/gi;
  bankInfo: any = {};
  countries = [];
  status = [
    {
      label: 'Requested',
      value: 0
    },
    {
      label: 'Pending',
      value: 1
    },
    {
      label: 'Success',
      value: 2
    },
    {
      label: 'Error',
      value: 3
    },
    {
      label: 'Rejected',
      value: 4
    },
    {
      label: 'Approved',
      value: 5
    },
    {
      label: 'Unconfirmed',
      value: 6
    },
    {
      label: 'Not enough balance',
      value: 7
    },
    {
      label: 'Waiting Email Confirm',
      value: 8
    },
    {
      label: 'Cancelled',
      value: 9
    }
  ];
  statusSticpay = this.status.filter(s => [0, 2, 3].includes(s.value));
  constructor(
    private service: WalletService,
    private appService: AppService,
    private exportService: ExportService,
    private fxNumber: DecimalPipe,
    private datePipe: DatePipe
  ) {
    this.countries = Constants.COUNTRIES.map((c) => {
      return { label: c.name, value: c.code };
    });
  }

  ngOnInit(): void {
    this.getRequest();
  }
  onKeyup(event): void {
    if (event.keyCode === 13) {
      this.searchTransaction();
    }
  }

  getColumnsExport(): ExportExcelColumn<SticpayTransactionRequest | BankRequest>[] {
    let columns = []
    switch (this.type) {
      case "sticpay-transactions":
        columns = this.getColumnExportStickyTransactions();
        break;
      case "banking-deposits":
        columns = this.getColumnExportBankingDeposits();
        break;
      case "bitgo-deposits":
        columns = this.getColumnExportBitgoDeposits();
        break;
      case "banking-withdraws":
        columns = this.getColumnExportBankingWithdraws();
        break;
    }
    return columns;
  }

  getColumnExportBankingDeposits(): ExportExcelColumn<BankRequest>[] {
    return [
      {
        field: 'id',
        title: 'ID',
        width: 30
      },
      {
        field: 'userName',
        title: 'User Name	',
        transform: (data: BankRequest) => {
          return data.getUsername();
        },
        width: 200
      },
      {
        field: 'email',
        title: 'Email',
        width: 150
      },
      {
        field: 'login',
        title: 'MT5 Account',
        width: 70
      },
      {
        field: 'asset',
        title: 'Currency',
        transform: (data: BankRequest, datas) => {
          return data.asset?.toUpperCase();
        },
        width: 50
      },
      {
        field: 'amount',
        title: 'Amount',
        transform: (data: BankRequest, datas) => {
          let value = this.fxNumber.transform(
            +(data.amount),
            Constants.FIXED_NUMBER[data.asset]
          );
          return value;
        },
        width: 100
      },
      {
        field: 'createTime',
        title: 'Date',
        transform: (data: BankRequest, datas) => {
          return this.datePipe.transform(data.createTime, "yyyy/MM/dd");
        },
        width: 100
      },
    ]
  }

  getColumnExportBitgoDeposits(): ExportExcelColumn<BankRequest>[] {
    return [
      {
        field: 'id',
        title: 'ID',
        width: 30
      },
      {
        field: 'userName',
        title: 'User Name	',
        transform: (data: BankRequest) => {
          return data.getUsername();
        },
        width: 200
      },
      {
        field: 'email',
        title: 'Email',
        width: 150
      },
      {
        field: 'login',
        title: 'MT5 Account',
        width: 70
      },
      {
        field: 'asset',
        title: 'Currency',
        transform: (data: BankRequest, datas) => {
          return data.asset?.toUpperCase();
        },
        width: 50
      },
      {
        field: 'amount',
        title: 'Amount',
        transform: (data: BankRequest, datas) => {
          let value = this.fxNumber.transform(
            +(data.amount),
            Constants.FIXED_NUMBER[data.asset]
          );
          return value;
        },
        width: 100
      },
      {
        field: 'createTime',
        title: 'Date',
        transform: (data: BankRequest, datas) => {
          return this.datePipe.transform(data.createTime, "yyyy/MM/dd");
        },
        width: 100
      }
    ]
  }

  getColumnExportBankingWithdraws(): ExportExcelColumn<BankRequest>[] {
    return [
      {
        field: 'id',
        title: 'ID',
        width: 30
      },
      {
        field: 'ibId',
        title: 'IBID',
        width: 30
      },
      {
        field: 'userName',
        title: 'User Name	',
        transform: (data: BankRequest) => {
          return data.getUsername();
        },
        width: 200
      },
      {
        field: 'email',
        title: 'Email',
        width: 150
      },
      {
        field: 'login',
        title: 'MT5 Account',
        width: 70
      },
      {
        field: 'asset',
        title: 'Currency',
        transform: (data: BankRequest, datas) => {
          return data.asset?.toUpperCase();
        },
        width: 50
      },
      {
        field: 'amount',
        title: 'Nominal Volume',
        transform: (data: BankRequest, datas) => {
          let value = this.fxNumber.transform(
            +(data.amount),
            Constants.FIXED_NUMBER[data.asset]
          );
          return value;
        },
        width: 100
      },
      {
        field: 'withdrawFee',
        title: 'Fee',
        transform: (data: BankRequest, datas) => {
          let value = this.fxNumber.transform(
            +(data.withdrawFee),
            Constants.FIXED_NUMBER[data.asset]
          );
          return value;
        },
        width: 100
      },
      {
        field: 'actualVolume',
        title: 'Actual Volume',
        transform: (data: BankRequest, datas) => {
          let value = this.fxNumber.transform(
            Number(data.amount) - Number(data.withdrawFee),
            Constants.FIXED_NUMBER[data.asset]
          );
          return value;
        },
        width: 100
      },
      {
        field: 'createTime',
        title: 'Date',
        transform: (data: BankRequest, datas) => {
          return this.datePipe.transform(data.createTime, "yyyy/MM/dd");
        },
        width: 100
      },
      {
        field: 'status',
        title: 'Status',
        transform: (data: BankRequest, datas) => {
          return data.getStatus();
        },
        width: 100
      },
    ]
  }

  getColumnExportStickyTransactions(): ExportExcelColumn<SticpayTransactionRequest>[] {
    return [
      {
        field: 'id',
        title: 'ID',
        width: 30
      },
      {
        field: 'userName',
        title: 'User Name',
        transform: (data: SticpayTransactionRequest) => {
          return data.getUsername();
        },
        width: 200
      },
      {
        field: 'email',
        title: 'Email',
        width: 150
      },
      {
        field: 'login',
        title: 'MT5 Account',
        width: 70
      },
      {
        field: 'asset',
        title: 'Currency',
        transform: (data: SticpayTransactionRequest, datas) => {
          return data.asset?.toUpperCase();
        },
        width: 50
      },
      {
        field: 'paymentId',
        title: 'Transaction ID',
        transform: (data: SticpayTransactionRequest, datas) => {
          return data.paymentId?.toUpperCase();
        },
        width: 250
      },
      {
        field: 'amount',
        title: 'Requested Amount',
        transform: (data: SticpayTransactionRequest, datas) => {
          let value = this.fxNumber.transform(
            +(data.amount),
            Constants.FIXED_NUMBER[data.asset]
          );
          return value;
        },
        width: 100
      },
      {
        field: 'withdrawFee',
        title: 'Fee',
        transform: (data: SticpayTransactionRequest, datas) => {
          if (data.status == 2) {
            let value = this.fxNumber.transform(
              Number(data.amount) - Number(data.actualAmount),
              Constants.FIXED_NUMBER[data.asset]
            );
            return value;
          }
        },
        width: 100
      },
      {
        field: 'actualAmount',
        title: 'Actual Amount',
        transform: (data: SticpayTransactionRequest, datas) => {
          if (data.status == 2) {
            let value = this.fxNumber.transform(
              +data.actualAmount,
              Constants.FIXED_NUMBER[data.asset]
            );
            return value;
          }
        },
        width: 100
      },
      {
        field: 'createTime',
        title: 'Date',
        transform: (data: SticpayTransactionRequest, datas) => {
          return this.datePipe.transform(data.createTime, "yyyy/MM/dd");
        },
        width: 100
      },
      {
        field: 'status',
        title: 'Status',
        transform: (data: SticpayTransactionRequest, datas) => {
          return data.getStatus();
        },
        width: 100
      }
    ]
  }

  exportExcel() {
    const columns = this.getColumnsExport();
    this.exportService.exportExcel<SticpayTransactionRequest | BankRequest>({
      fileName: `${this.type}_transaction.xls`,
      data: async (pageRequest) => {
        let option = {
          q: (this.condition.keyword) ? encodeURIComponent((this.condition.keyword).trim()) : this.condition.keyword,
          status: this.condition.status,
          page: pageRequest.pageIndex + 1,
          page_size: pageRequest.pageSize,
          code:'',
          asset:'',
          type: ''
        };
        let model = BankRequest;
        switch (this.type) {
          case 'sticpay-transactions':
            model = SticpayTransactionRequest;
            break;
          default:
            model = BankRequest
            break;
        }
    
        const res = await this.service.getRequests<SticpayTransactionRequest | BankRequest>(option, this.type, model).toPromise();
        return {
          items: res?.data ?? [],
          total: res?.paging?.total ?? 0
        }
      },
      columns: columns
    })
  }

  searchTransaction(search?: boolean): void {
    this.pageInfo.pageIndex = 1;
    this.getRequest();
  }
  private getRequest(): void {
    let option = {
      q: (this.condition.keyword) ? encodeURIComponent((this.condition.keyword).trim()) : this.condition.keyword,
      status: this.condition.status,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
      code:'',
      asset:'',
      type: ''
    };
    let model = BankRequest;
    switch (this.type) {
      case 'sticpay-transactions':
        model = SticpayTransactionRequest;
        break;
      default:
        model = BankRequest
        break;
    }

    this.service.getRequests(option, this.type, model)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.data = res.data;
          this.pageInfo.totalRecord = res.paging.total;
        }
      });
  }
  onChangeStatusProcess(item, type): void {
    this.appService
      .confirm({
        title: `Are you sure that you want to ${(type === 4) ? 'rejected' : 'approve'} bank withdraw?`,
        ok: 'Yes',
        cancel: 'No',
      })
      .subscribe((v: any) => {
        if (v.result) {
          const body = {
            payment_id: item.paymentId,
            state: (type === 4) ? 'rejected' : 'approved'
          };
          this.pointUpdate = item.id;
          this.loading = true;
          this.service.updateStatusBankRequest(body)
            .subscribe(res => {
              this.loading = false;
              this.pointUpdate = null;
              if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
                this.appService.showSuccess( `${(type === 4) ? 'Rejected' : 'Approved'} success`);
                this.getRequest();
              } else {
                this.appService.showError(`${(type === 4) ? 'Rejected' : 'Approved'} fail`);
              }
            });
        }
      });
  }
  getBankInfo(item): void {
    this.service.getBankDocument(item.userId)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.bankInfo = {
            email: item.email,
            username: item.getUsername(),
            data: res.data
          };
        }
      });
  }
  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.getRequest();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
